import React from 'react';
import SEO from '../components/SEO';
import Header from '../components/Header';
import Hero from '../components/Hero';
import InfoModal from '../components/InfoModal';
import ContentSection from '../components/ContentSection';
import AboutRImage from '../components/AboutRImage';
import Footer from '../components/Footer';
import '../styles/App.css';
import '../styles/Hero.css';
import HeroImage from '../assets/images/app/dashboard.png';
import CoachCTAImage from '../assets/images/CTA_Coach.png';

// App screenshots - user will provide PNGs
// For now, using placeholder imports - user can replace with actual iOS/iPad images
import DashboardImg from '../assets/images/app/dashboard.png';
import MacrocycleImg from '../assets/images/app/macrocycle.png';
import PerformanceImg from '../assets/images/app/performance-tracker.png';
import DashboardWorkoutBlackImg from '../assets/images/app/Dashboard_and_workout_v2_black.png';

function Home() {
  const programItems = [
    { title: 'Multi-Sport', description: 'Sprint & Olympic Triathlon' },
    { title: 'Longevity', description: 'Pre-menopause & 40+' },
    { title: 'Volleyball', description: 'Power & Flexibility' },
    { title: 'Beginners thru Advanced', description: 'Programs for Functional Strength' },
  ];

  const featuresContent = {
    sectionTitle: (
      <>
        Functional <span style={{ color: 'red' }}>Strength</span>
      </>
    ),
    sectionDescription:
      'Programs for every athlete. Every age. Every starting point.',
    items: [
      {
        title: 'Your Training Dashboard',
        imageSrc: DashboardImg,
        imagePosition: 'right',
        body1: (
          <p>
            Access your daily workouts, track progress, and stay on top of your training schedule—all from your iPhone or iPad.
          </p>
        ),
      },
      {
        imagePosition: 'alternating',
        sections: [
          {
            subtitle: 'Program Management',
            imageSrc: MacrocycleImg,
            imagePosition: 'right',
            body: 'View your macrocycle and mesocycle progress, manage your program, and see your training timeline at a glance.',
          },
          {
            subtitle: 'Performance Tracking',
            imageSrc: PerformanceImg,
            imagePosition: 'left',
            body: 'Monitor your activity trends, view detailed charts, and track your consistency over time—all optimized for mobile viewing.',
          },
        ],
      },
      {
        title: 'Optimized for iOS & iPad',
        imageSrc: DashboardWorkoutBlackImg,
        imagePosition: 'inside',
        body1: (
          <p>
            The Begin Strength app is designed specifically for Apple devices, taking full advantage of iOS and iPadOS features. Whether you're at the gym, on the go, or reviewing your progress at home, the app delivers a seamless experience.
          </p>
        ),
      },
    ],
  };

  return (
    <div className="home">
      <SEO
        title="Begin Strength Mobile App"
        description="Download the Begin Strength app for iOS and iPad. Access your training programs, track workouts, and monitor progress on the go."
        image="/og-images/programs.png"
        path="/"
      />
      <Header />
      <main>
        <Hero
          backgroundImage={HeroImage}
          headerText={
            <>
              Begin <br /><span style={{ color: 'red' }}>Strength</span>
            </>
          }
          paragraphText={
            <p>
              Begin Strength mobile app offers multiple programs for every kind of athlete—youth, beginners, intermediates, multi-sport athletes, busy parents, and those rebuilding strength.
            </p>
          }
          primaryButtonText="Programs"
          primaryButtonLink="/programs"
          secondaryButtonText="Download App"
          secondaryButtonLink="/app"
        />

        <InfoModal items={programItems} />

        <ContentSection
          sectionTitle={featuresContent.sectionTitle}
          sectionDescription={featuresContent.sectionDescription}
          items={featuresContent.items}
          sectionClass="faq-sub-section"
          showNumbers={false}
        />

        <AboutRImage
          title={
            <>
              Are You a Volleyball Coach or Run a <span style={{ color: 'red' }}>Club?</span>
            </>
          }
          copy="Offer the Begin Strength Volleyball Program to your athletes. Steer the program—set workouts per week, block practice days. Get your landing page, see your roster by age group. Youth get a discounted rate through your program."
          imageSrc={CoachCTAImage}
          primaryButtonText="Learn More"
          primaryButtonLink="/clubs"
        />

        <Footer />
      </main>
    </div>
  );
}

export default Home;
